module.exports = __webpack_public_path__ + "img/ic_arrow_back_48px_white.5a8f0573.svg";